import { Clear, ExpandLess, ExpandMore, FilterList } from "@mui/icons-material";
import { Box, Chip, Collapse, FormControl, IconButton, InputLabel, Paper, Stack, styled } from "@mui/material";
import React, { useEffect, useState } from "react";
import { TextField } from "../Input";
import { useFlag } from "../utils";
export const OutlinedContainer = styled(Box)(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(1),
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.divider}`,
}));
export function Filter(props) {
    const { label, active, enableSearch, onSearch, onClear, variant, labels, paper = true, onFilterClick, onChangeOpen, children, } = props;
    const [open, setOpen, , toggleOpen] = useFlag(false);
    const [value, setValue] = useState("");
    function handleKeyDown(e) {
        if (onSearch) {
            if (e.key == "Enter") {
                onSearch(value);
                setValue("");
            }
        }
    }
    useEffect(() => {
        if (open && onFilterClick) {
            onFilterClick();
        }
    }, [onFilterClick, open]);
    useEffect(() => {
        if (onChangeOpen) {
            onChangeOpen(open);
        }
    }, [onChangeOpen, open]);
    const hasActiveFilter = Boolean(active === null || active === void 0 ? void 0 : active.filter(node => Boolean(node)).length);
    return (React.createElement(Box, null,
        React.createElement(FormControl, { variant: variant, fullWidth: true, onClick: enableSearch ? undefined : toggleOpen },
            label && (React.createElement(InputLabel, { shrink: true }, label)),
            React.createElement(OutlinedContainer, null,
                React.createElement(Stack, { sx: {
                        flexDirection: {
                            xs: "column",
                            sm: "row",
                        },
                        alignItems: "center",
                        width: "100%",
                    }, spacing: 1, useFlexGap: true },
                    children && (React.createElement(IconButton, { onClick: enableSearch ? toggleOpen : undefined, sx: {
                            display: {
                                xs: "none",
                                sm: "inline-flex",
                            },
                        } },
                        React.createElement(FilterList, null))),
                    React.createElement(Stack, { direction: "row", alignItems: "center", sx: {
                            justifyContent: {
                                xs: "center",
                                sm: "flex-start",
                            },
                        }, flexWrap: "wrap", spacing: 1, useFlexGap: true, flex: 1 },
                        active,
                        enableSearch && (React.createElement(TextField, { value: value, onChange: setValue, onKeyDown: handleKeyDown, variant: "standard", placeholder: enableSearch ? labels("search") : undefined }))),
                    React.createElement(Stack, { direction: "row", spacing: 1, alignItems: "center" },
                        !hasActiveFilter && (React.createElement(Chip, { variant: "outlined", label: labels("none"), clickable: true, onClick: enableSearch ? setOpen : undefined })),
                        hasActiveFilter && onClear && (React.createElement(IconButton, { onClick: onClear, title: labels("reset") },
                            React.createElement(Clear, null))),
                        children && (React.createElement(IconButton, { onClick: enableSearch ? toggleOpen : undefined, edge: "end" }, open ? React.createElement(ExpandLess, null) : React.createElement(ExpandMore, null))))))),
        children && (React.createElement(Collapse, { in: open, mountOnEnter: true, unmountOnExit: true }, paper
            ? (React.createElement(Paper, { elevation: 2 }, children))
            : children))));
}
//# sourceMappingURL=Filter.js.map